import React from 'react';
import { useLingui } from '@lingui/react/macro';

import MegaphoneWhite from '@rover/icons/svg/megaphone-white.svg';
import { Button } from '@rover/kibble/core';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { SitterProfileClickShareYourProfile } from './analyticsEvents';

const PromoteProfileButton = ({
  fullWidth = false,
  isRevampLayout = false,
}: {
  fullWidth?: boolean;
  isRevampLayout?: boolean;
}): JSX.Element => {
  const { t } = useLingui();
  const pageVariantProps = isRevampLayout ? { pageVariant: 'revamp' as const } : {};
  return (
    <Button
      fullWidth={fullWidth}
      px={isRevampLayout ? '6x' : undefined}
      href="/provider-profile/promote/"
      icon={MegaphoneWhite}
      variant="primary"
      onClick={() => emitAnalyticsEvent(new SitterProfileClickShareYourProfile(pageVariantProps))}
    >
      {t`Promote your profile`}
    </Button>
  );
};

export default PromoteProfileButton;
